export var ORMEntityPermission;
(function (ORMEntityPermission) {
    ORMEntityPermission["Read"] = "canRead";
    ORMEntityPermission["Write"] = "canEdit";
})(ORMEntityPermission || (ORMEntityPermission = {}));
//# sourceMappingURL=orm-entity-permission.js.map